module.exports = {
	"classes": [
		"b2e",
		"header-dark"
	],
	"title": "Better Identity Management for Your Organization",
	"metas": {
		"description": "As your organization continues to grow managing identities becomes strenuous. Accelerate your growth with an enterprise-class identity management solution."
	},
	"opengraph": {
		"og:title": "Better Identity Management for Your Organization",
		"og:description": "As your organization continues to grow managing identities becomes strenuous. Accelerate your growth with an enterprise-class identity management solution.",
		"og:url": "https://auth0.com/b2e-identity-management-for-employees",
		"og:image": "https://cdn.auth0.com/website/assets/pages/b2e/img/b2e-twitter-card-cbb9ef6a5e.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/b2e/img/b2e-twitter-card-cbb9ef6a5e.png"
	},
	"twittercard": {
		"twitter:title": "Better Identity Management for Your Organization",
		"twitter:description": "As your organization continues to grow managing identities becomes strenuous. Accelerate your growth with an enterprise-class identity management solution.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/b2e/img/b2e-twitter-card-cbb9ef6a5e.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2e/metadata.json
// module id = 1370
// module chunks = 0